"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSecretaryOutput = instanceOfSecretaryOutput;
exports.SecretaryOutputFromJSON = SecretaryOutputFromJSON;
exports.SecretaryOutputFromJSONTyped = SecretaryOutputFromJSONTyped;
exports.SecretaryOutputToJSON = SecretaryOutputToJSON;
var Secretary_1 = require("./Secretary");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the SecretaryOutput interface.
 */
function instanceOfSecretaryOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function SecretaryOutputFromJSON(json) {
    return SecretaryOutputFromJSONTyped(json, false);
}
function SecretaryOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Secretary_1.SecretaryFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function SecretaryOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Secretary_1.SecretaryToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
